import(/* webpackMode: "eager", webpackExports: ["RegistrationForm"] */ "/workspace/src/components/auth/register-form.tsx");
